var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ImageWebp",class:_vm.className,style:(_vm.styleName),attrs:{"src":_vm.newSrc,"alt":_vm.alt,"srcset":_vm.srcset,"width":_vm.width},on:{"error":function($event){return _vm.$emit('error', $event)},"load":function($event){return _vm.$emit('load', $event)},"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }